import { useSearchParams, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

const ReadCompanies = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  // Преобразуем параметры в объект
  const paramsObject = Object.fromEntries(searchParams.entries());

  useEffect(() => {
    localStorage.removeItem('group');
    if (paramsObject.id) {
      localStorage.setItem('company', JSON.stringify({ id: Number(paramsObject.id) }));
    }
    navigate('/app');
  }, [paramsObject.id, navigate]);

  return null;
};

export default ReadCompanies;
